import { Switch as MantineSwitch } from "@mantine/core";
import clsx from "clsx";
import { forwardRef } from "react";
import { ComponentProps } from "react";

import styles from "./Switch.module.scss";

type SwitchEventType = {
  target: {
    name?: string;
    value: boolean;
    type: string;
  };
};

type SwitchProps = Pick<
  ComponentProps<typeof MantineSwitch>,
  | "label"
  | "checked"
  | "onChange"
  | "disabled"
  | "className"
  | "classNames"
  | "labelPosition"
> & {
  name?: string;
  ref?: React.Ref<HTMLInputElement>;
  onBlur?: (event: SwitchEventType) => void;
  value?: string | number | readonly string[];
  withText?: {
    on: string;
    off: string;
  };
};

const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ onChange, checked, name, onBlur, disabled, withText, ...rest }, ref) => {
    const showText = Boolean(withText);

    return (
      // @ts-expect-error TS2339 non-existing className
      <div className={clsx(styles.switch, { [styles.showText]: showText })}>
        <MantineSwitch
          disabled={disabled}
          ref={ref}
          name={name}
          checked={checked}
          onChange={(e) => {
            if (onChange) {
              const syntheticEvent = {
                target: {
                  name,
                  value: e.currentTarget.checked,
                  checked: e.currentTarget.checked,
                  type: "checkbox",
                },
                currentTarget: {
                  checked: e.currentTarget.checked,
                },
                type: "change",
              } as unknown as React.ChangeEvent<HTMLInputElement>;

              onChange(syntheticEvent);
            }
          }}
          onBlur={(e) => {
            if (onBlur) {
              const syntheticEvent: SwitchEventType = {
                target: {
                  name,
                  value: e.currentTarget.checked,
                  type: "checkbox",
                },
              };
              onBlur(syntheticEvent);
            }
          }}
          classNames={{
            // @ts-expect-error TS2339 non-existing className
            body: styles.body,
            // @ts-expect-error TS2339 non-existing className
            input: styles.input,
            track: styles.track,
            thumb: styles.thumb,
            // @ts-expect-error TS2339 non-existing className
            label: styles.label,
            ...rest.classNames,
          }}
          {...rest}
        />

        {showText && (
          <div className={styles.innerLabel}>
            {checked ? withText!.on : withText!.off}
          </div>
        )}
      </div>
    );
  },
);

Switch.displayName = "Switch";

export default Switch;
